<template lang="pug">
  .stepper-top.no-select
    h3.header-title.text-center(v-text="currentTitle")
    .header-message(v-if="getRobotMessage")
      p.paragraph(v-html="getRobotMessage")
      i.logo-badge(:class="{ 'is-bbg-logo': isBBG }")
        img.bbg-logo(v-if="isBBG" :src="bbgLogoSrc" alt="BBG Advisor logo")
        UiIcon(v-else :icon="robotLogoIcon")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheStepperTop',
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Wizard SM
    ...mapGetters('moduleWizard', [
      'getCurrentRouteName',
      'getRobotMessage'
    ]),
    // Robot badge logo icon
    robotLogoIcon () {
      return this.$store.state.config.branded === 'bbg'
        ? 'logo-bbg-advisor'
        : 'logo-with-gaps'
    },
    // BBG brand flag
    isBBG () {
      return this.$store.state.config.branded === 'bbg'
    },
    // Raw BBG logo file path
    bbgLogoSrc () {
      return require('@/assets/img/Logo_pic_yellow.svg')
    },
    // Current title
    currentTitle () {
      const routeName = this.getCurrentRouteName
      if (routeName === 'init') return 'Подключение'
      if (routeName === 'initials') {
        if (this.$store.state.config.branded === 'anderida') return 'Знакомство'
        if (this.$store.state.config.branded === 'ds') return 'Знакомство'
        if (this.$store.state.config.branded === 'scapital') return 'Знакомство'
        return 'Идентификация'
      }
      if (routeName === 'account') {
        if (this.$store.state.config.branded === 'anderida') return 'Учетная запись'
        if (this.$store.state.config.branded === 'ds') return 'Учетная запись'
        if (this.$store.state.config.branded === 'scapital') return 'Учетная запись'
        return 'Допуск'
      }
      if (routeName === 'poll') {
        if (this.$store.state.config.branded === 'anderida') return 'Анкета инвестора'
        if (this.$store.state.config.branded === 'ds') return 'Анкета инвестора'
        if (this.$store.state.config.branded === 'scapital') return 'Анкета инвестора'
        return 'Аватар инвестора'
      }
      if (routeName === 'deposit') {
        if (this.$store.state.config.branded === 'anderida') return 'Стратегия инвестиций'
        if (this.$store.state.config.branded === 'ds') return 'Стратегия инвестиций'
        if (this.$store.state.config.branded === 'scapital') return 'Стратегия инвестиций'
        return 'Стратегия инвестиций'
      }
      if (routeName === 'risk') {
        if (this.$store.state.config.branded === 'anderida') return 'Оценка рисков'
        if (this.$store.state.config.branded === 'ds') return 'Оценка рисков'
        if (this.$store.state.config.branded === 'scapital') return 'Оценка рисков'
        return 'Таргетирование'
      }
      if (routeName === 'activation') {
        if (this.$store.state.config.branded === 'anderida') return 'Регистрация счёта'
        if (this.$store.state.config.branded === 'ds') return 'Регистрация счёта'
        if (this.$store.state.config.branded === 'scapital') return 'Регистрация счёта'
        return 'Завершение настроек'
      }
      if (routeName === 'portfolio') {
        if (this.$store.state.config.branded === 'anderida') return 'Структура портфеля'
        if (this.$store.state.config.branded === 'ds') return 'Структура портфеля'
        if (this.$store.state.config.branded === 'scapital') return 'Структура портфеля'
        return 'Состав портфеля'
      }
      if (routeName === 'user-agreements') return 'Cоглашение'
      if (routeName === 'terms-of-use') return 'Правила пользования'
      if (routeName === 'privacy-policy') return 'Персональные данные'
      return 'Unknown'
    }
  }
}
</script>
